module.exports = __webpack_public_path__ + "static/media/Messenger-min.172e9914.png";